import { sortBy } from 'lodash'

import { positionReset } from '../helpers/lists'

/**
 * @typedef {import('pltr').AttributeValue} AttributeValue
 */

/**
 * @typedef HasPositionAndDisplayedAttributes
 * @property {Array<AttributeValue>} [attributes]
 * @property {number} [position]
 */

/**
 * @template A
 * @param {Array<A>} items
 * @param {number | Null} attributeId
 * @param {'all' | number | Null} bookId
 * @return {Array<A>}
 */
const sortManually = (items, attributeId, bookId) => {
  return sortBy(items, (item) => {
    const theAttribute = (attribute) => {
      return attribute.id === attributeId && attribute.bookId == bookId
    }
    if (typeof item === 'object' && item) {
      if (attributeId && 'attributes' in item && Array.isArray(item.attributes)) {
        return item.attributes?.find(theAttribute)?.value ?? 0
      } else if ('position' in item && item && typeof item.position === 'number') {
        return item.position
      } else {
        return 0
      }
    } else {
      return 0
    }
  })
}

/**
 * @param {any} x
 * @return {any | String}
 */
const lowercaseIfString = (x) => {
  if (typeof x === 'string') {
    return x.toLowerCase()
  } else {
    return x
  }
}

/**
 * @template A
 * @param {Record<String, Array<A>>} visibleByCategory
 * @param {String} sort A string containing the attribute to sort by and the direction of sorting separated by a tilde character "~"
 * @param {boolean} isManuallySorted
 * @param {number | Null} attributeId
 * @param {'all' | number | Null} bookId
 * @return {Record<String, Array<A>>}
 */
export function sortEachCategory(visibleByCategory, sort, isManuallySorted, attributeId, bookId) {
  const sortOperands = sort.split('~')
  const attrName = sortOperands[0]
  const attrExtractor =
    attrName === 'last edited'
      ? (entity) => {
          if (typeof entity.lastEdited !== 'number') {
            return 0
          } else {
            return entity.lastEdited
          }
        }
      : (entity) => entity[attrName]
  const direction = sortOperands[1]
  const sortByOperand =
    attrName === 'name'
      ? [(x) => lowercaseIfString(attrExtractor(x)), (x) => lowercaseIfString(x.id)]
      : [(x) => lowercaseIfString(attrExtractor(x)), (x) => lowercaseIfString(x.name)]

  return Object.keys(visibleByCategory).reduce((acc, k) => {
    const itemsInCategory = visibleByCategory[k]

    const sorted = isManuallySorted
      ? sortManually(itemsInCategory, attributeId, bookId)
      : positionReset(sortBy(itemsInCategory, sortByOperand))

    if (direction == 'desc') sorted.reverse()
    return {
      ...acc,
      [k]: sorted,
    }
  }, {})
}
